/* HEY CHARLIE Pre-Launch-Seite.
 *
 * Vier Aufgaben: Überschriften auf die Breite rechnen, Countdown, Anmeldung
 * und die drei Overlays. Die beiden Schriftgrößen-Funktionen stammen
 * unverändert aus der Design-Vorlage.
 */
(function () {
  'use strict';

  // ---- Überschriften ---------------------------------------------------

  function fit() {
    var mobile = window.innerWidth <= 820;
    document.querySelectorAll('[data-fit]').forEach(function (el) {
      if (mobile && !el.dataset.maxm) {
        el.style.fontSize = '';
        return;
      }
      var cap = +(mobile ? el.dataset.maxm : el.dataset.max);
      el.style.fontSize = '100px';
      var width = el.clientWidth;
      var widest = 0;
      el.querySelectorAll('span').forEach(function (span) {
        widest = Math.max(widest, span.getBoundingClientRect().width);
      });
      if (widest) el.style.fontSize = Math.min(cap, Math.floor((100 * width) / widest * 0.98)) + 'px';
    });
  }

  // Am Desktop schrumpft die ganze Zeile, am Handy wird jede Wortgruppe
  // einzeln auf die volle Breite gezogen.
  function fitH1() {
    var el = document.querySelector('.p3-h1');
    if (!el) return;

    el.style.removeProperty('font-size');
    el.querySelectorAll('span').forEach(function (span) { span.style.removeProperty('font-size'); });

    if (window.innerWidth <= 820) {
      var width = el.clientWidth;
      el.querySelectorAll('span').forEach(function (span) {
        span.style.setProperty('font-size', '100px', 'important');
        var w = span.getBoundingClientRect().width;
        span.style.setProperty('font-size', Math.min(130, Math.floor((100 * width) / w * 0.99)) + 'px', 'important');
      });
      return;
    }

    // Desktop: Die breiteste Zeile gibt die Größe vor. Über scrollWidth zu
    // gehen reicht nicht — umbrochener Text läuft nicht über, er bricht um.
    var rows = el.querySelectorAll('.ln');
    if (!rows.length) return;

    var box = el.clientWidth;
    el.style.setProperty('font-size', '100px', 'important');
    var widest = 0;
    // Die Zeile ist ein Block und damit immer so breit wie die Spalte. Zum
    // Messen kurz auf max-content stellen — scrollWidth hilft hier nicht,
    // Chrome gibt bei overflow:visible die Spaltenbreite zurück.
    rows.forEach(function (row) {
      row.style.width = 'max-content';
      widest = Math.max(widest, row.getBoundingClientRect().width);
      row.style.width = '';
    });
    if (!widest) return;

    var cap = parseFloat(el.dataset.max || 70);
    el.style.setProperty('font-size', Math.min(cap, Math.floor((100 * box) / widest * 0.99)) + 'px', 'important');
  }

  function measure() { fit(); fitH1(); }

  measure();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  window.addEventListener('resize', measure);

  // ---- Countdown -------------------------------------------------------

  var board = document.getElementById('cd');
  var openBoard = document.getElementById('cdOpen');

  function showOpen() {
    if (board) board.hidden = true;
    if (openBoard) openBoard.hidden = false;
  }

  if (board && openBoard) {
    // Das Zieldatum bringt seine Zeitzone mit, deshalb stimmt die Anzeige
    // unabhängig davon, wo der Besucher sitzt.
    var target = new Date(board.getAttribute('data-hc-countdown')).getTime();

    var setDigits = function (id, value) {
      var el = document.getElementById(id);
      if (!el) return;
      var text = String(value).padStart(2, '0');
      if (el.dataset.v === text) return;
      el.dataset.v = text;
      el.innerHTML = text.split('').map(function (c) { return '<span>' + c + '</span>'; }).join('');
      el.classList.remove('flip');
      void el.offsetWidth;
      el.classList.add('flip');
    };

    var tick = function () {
      if (isNaN(target)) return;
      var left = Math.floor((target - Date.now()) / 1000);
      if (left <= 0) {
        showOpen();
        return;
      }
      setDigits('cdD', Math.floor(left / 86400));
      setDigits('cdH', Math.floor((left % 86400) / 3600));
      setDigits('cdM', Math.floor((left % 3600) / 60));
      setDigits('cdS', left % 60);
    };

    tick();
    setInterval(tick, 1000);
    if (new URLSearchParams(window.location.search).get('open') === '1') showOpen();
  }

  // ---- Overlays --------------------------------------------------------

  var lastFocus = null;

  function openOverlay(name) {
    var overlay = document.querySelector('[data-hc-overlay="' + name + '"]');
    if (!overlay) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('hc-ov-open');
    var box = overlay.querySelector('.hc-ov__box');
    if (box) box.focus();
  }

  function closeOverlays() {
    var open = false;
    document.querySelectorAll('[data-hc-overlay]').forEach(function (overlay) {
      if (!overlay.hidden) open = true;
      overlay.hidden = true;
    });
    if (!open) return;
    document.body.classList.remove('hc-ov-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-hc-overlay-open]');
    if (opener) {
      event.preventDefault();
      openOverlay(opener.getAttribute('data-hc-overlay-open'));
      return;
    }
    if (event.target.closest && event.target.closest('[data-hc-overlay-close]')) {
      event.preventDefault();
      closeOverlays();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') closeOverlays();
  });

  // Falsches Passwort: Shopify lädt die Seite neu, das Overlay ist dann
  // serverseitig schon offen — hier nur noch Scrollsperre und Fokus.
  var preopened = document.querySelector('[data-hc-overlay]:not([hidden])');
  if (preopened) {
    document.body.classList.add('hc-ov-open');
    var field = preopened.querySelector('input');
    if (field) field.focus();
  }

  // ---- Anmeldung -------------------------------------------------------

  var hero = document.querySelector('.p3-hero');
  var form = document.querySelector('.p3-f');
  if (!hero || !form) return;

  var company = (hero.getAttribute('data-klaviyo-company') || '').trim();
  var list = (hero.getAttribute('data-klaviyo-list') || '').trim();
  var source = (hero.getAttribute('data-signup-source') || 'prelaunch').trim();

  var button = form.querySelector('.p3-btn');
  var input = form.querySelector('input[type="email"]');
  var note = form.querySelector('.p3-fine');
  var noteText = note ? note.innerHTML : '';

  function say(message) {
    if (!note) return;
    note.innerHTML = message;
  }

  function restore() {
    if (button) button.disabled = false;
    say(noteText);
  }

  function klaviyo(email) {
    var attributes = { email: email, properties: { signup_source: source } };
    var headers = { 'Content-Type': 'application/json', revision: '2024-10-15' };

    // Erst das Profil mit der Eigenschaft anlegen, dann eintragen — sonst
    // prüft der Flow seinen Filter, bevor signup_source am Profil steht.
    return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ data: { type: 'profile', attributes: attributes } }),
    })
      .catch(function () {})
      .then(function () {
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: { profile: { data: { type: 'profile', attributes: attributes } } },
              relationships: { list: { data: { type: 'list', id: list } } },
            },
          }),
        });
      })
      .then(function (response) {
        if (!response || !response.ok) throw new Error('klaviyo');
      });
  }

  // Zusätzlich als Shopify-Kunde anlegen, ohne die Seite zu wechseln.
  function shopifyCustomer() {
    return fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
    }).catch(function () {});
  }

  form.addEventListener('submit', function (event) {
    if (!company || !list) return; // Ohne Klaviyo-Angaben das normale Formular lassen.
    event.preventDefault();

    if (input && !input.checkValidity()) {
      form.classList.add('err');
      say('Diese E-Mail-Adresse sieht noch nicht richtig aus.');
      if (input.reportValidity) input.reportValidity();
      return;
    }

    form.classList.remove('err');
    if (button) button.disabled = true;

    klaviyo(input.value.trim())
      .then(function () {
        shopifyCustomer();
        form.classList.add('is-success');
        if (input) input.readOnly = true;
      })
      .catch(function () {
        restore();
        say('Das hat gerade nicht geklappt. Bitte probier es noch einmal.');
      });
  });
})();
